
import React from 'react';
import QRCodeGenerator from './components/QRCodeGenerator';
import Chatbot from './components/Chatbot';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'; // For custom styling

function App() {
  return (
    <div className="App">
      <QRCodeGenerator />
      <Chatbot />
    </div>
  );
}

export default App;
